
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3cat/sx3",
      function () {
        return require("private-next-pages/3cat/sx3/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3cat/sx3"])
      });
    }
  